<template>
  <!--笔试选择 第3版-->
  <div id="jsbs">
    <!--引用公共头部-->
    <top-head :pageName="pageName"></top-head>
    <!--轮播图组件-->
    <jszg-banner :selectPeriodNum="subject" :period="period"></jszg-banner>
    <div class="nav1">
      <router-link :to="{name: 'Jsbs'}">笔试</router-link>
      <a class="active">面试</a>
      <router-link :to="{name: 'Jzbs'}">教师招聘</router-link>
    </div>
    <div id="navout">
      <div id="nav2" class="nav2" :class="{fixed: searchBarFixed}">
        <div class="swiper-container">
          <div class="swiper-wrapper" id="nav2wrapper">
            <div class="swiper-slide" v-for="(item, index) in periodData" :key="index">
              <a v-scroll-to="'#degree' + (index === 0 ? 1 : index)" @click="scrollto(item.id)" :class="{active: period === item.id}">{{item.name}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--通用中、小、幼-->
    <div class="degree" v-for="(item, index) in course1Data" :key="index">
      <div class="lightening" :id="'degree' + index"></div>
      <h2>{{item.title}}<span class="sub">{{item.label}}</span></h2>
      <div class="course1" v-for="(item2, index2) in item.content" :key="index2" @click="wheretoGo(item2.class_id, item2.jump_type, item2.signup)">
        <div class="left">
          <img :src="item2.class_app_img_1"  alt="">
        </div>
        <div class="right">
          <h4>{{item2.class_name}}</h4>
          <p class="detail">{{item2.class_name_main}}</p>
          <div v-if="item2.class_label">
            <span v-for="(item3, index3) in item2.class_label_details" :key="index3" :style="{'border-color': item3.label_bg_color ? item3.label_bg_color : '#000', 'color': item3.label_color ? item3.label_color : '#000'}" v-if="item3">
              {{item3.label_name}}
            </span>
          </div>
          <p class="people">{{item2.class_sum_price}}人报名</p>
          <b class="price" v-if="parseInt(item2.section_price + item2.section_price_decimal) === 0">0元</b>
          <b class="price" v-else>¥<span>{{item2.section_price}}</span>{{item2.section_price_decimal}}</b>
          <a class="bmst" v-if="item2.signup">去听课</a>
          <a class="bmst" v-else>查看课程</a>
        </div>
      </div>
      <div class="ad" v-if="item.advertisement[0]">
        <a :href="item4.href_url" v-for="(item4, index4) in item.advertisement" :key="index4">
          <img :src="item4.image" alt="item4.title">
        </a>
      </div>
    </div>
    <div id="free-listen">
      <h2>
        试听课程
        <span class="subtitle">
            好课试听试学
        </span>
      </h2>
      <div class="top">
        <a @click="wheretoGo(item.class_id, item.jump_type, item.signup)" v-for="(item, index) in freeListenData" :key="index" v-if="freeIndex === index"><img :src="item.class_app_img_2" :alt="item.title"></a>
      </div>
      <div class="bottom">
        <span :class="freeIndex === index ? 'active' : ''" v-on:click="changeListen" v-for="(item, index) in freeListenData" :key="index">{{item.class_name}}</span>
      </div>
    </div>
    <class-foot :selectPeriodNum="subject"></class-foot>
    <div class="reachbottom">-- 已经到底啦!!! --</div>
    <!--底部占位-->
    <div id="fix-bottom-void"></div>
    <bottom-bar :index="1"></bottom-bar>
  </div>
</template>

<script>
import {jsbsCourse, jsbsFreeListen, jsbsPeriods} from '../../request/api'
import jumpUrl from '../../assets/js/common'
import Vue from 'vue'
import BottomBar from '../share/fixed/BottomBar'
import topHead from '../share/header/topHead'
import jszgBanner from '../share/plug/jszgBanner'
import Swiper from 'swiper'
import VueScrollTo from 'vue-scrollto'
import classFoot from '../share/footer/classFoot'
let options = {
  container: 'body', // 滚动的容器
  duration: 500, // 滚动时间
  easing: 'ease', // 缓动类型
  offset: 0, // 滚动时应应用的偏移量。此选项接受回调函数
  force: true, // 是否应执行滚动
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
  bannerSwiperOb: null
}

Vue.use(VueScrollTo, options)

export default {
  name: 'Jsms',
  components: {
    BottomBar,
    classFoot,
    topHead,
    jszgBanner
  },
  data () {
    return {
      pageName: 'Jsms',
      subject: 2, // 默认值：1、笔试 2、面试 3、教招
      period: 0, // 默认值：全部
      course1Data: {},
      freeListenData: {},
      freeIndex: 0,
      periodData: {}, // 获得学段选择信息
      nav2SwiperOb: {},
      searchBarFixed: false,
      nav2Position: 0 // 定义导航固定位置
    }
  },
  methods: {
    changeListen (event) {
      let _this = this
      let _el = event.target
      let nodeList = event.target.parentNode.children
      let targetIndex = _this.tabIndex(_el, nodeList)
      this.freeIndex = targetIndex
    },
    /**
     * @param target 事件触发的元素
     * @param nodeList 元素集合
     * @returns {number} 返回事件触发元素的下标
     */
    tabIndex (target, nodeList) {
      for (let i = 0; i < nodeList.length; i++) {
        if (target === nodeList[i]) {
          return i
        }
      }
    },
    // 获得课程一数据
    getCourse1 () {
      let data = {
        subject: this.subject,
        period: this.period
      }
      jsbsCourse(data)
        .then(res => {
          console.log('课程列表：')
          console.log(res)
          this.course1Data = res
        })
        .catch(err => { console.log(err) })
    },
    // 获得学段信息
    getPeriods () {
      let data = {
        subject: this.subject
      }
      jsbsPeriods(data)
        .then(res => {
          console.log('学段：')
          console.log(res)
          this.periodData = res
          this.$nextTick(() => { // 下一帧渲染
            this.nav2Swiper()
            this.setSwiperInit()
          })
        })
        .catch(err => { console.log(err) })
    },
    // 获得免费试听
    getFreeListen () {
      let data = {
        subject: this.subject,
        period: this.period,
        page: 4
      }
      jsbsFreeListen(data)
        .then(res => {
          this.freeListenData = res
        })
        .catch(err => { console.log(err) })
    },
    nav2Swiper () {
      this.nav2SwiperOb = new Swiper('#nav2 .swiper-container', {
        initialSlide: 0,
        slidesPerView: 5,
        // spaceBetween: '4.27%',
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        slideShadows: true
      })
    },
    setSwiperInit () {
      setTimeout(() => {
        // document.getElementsByClassName('swiper-wrapper')[1].style.transform = 'translate3d(0px, 0px, 0px)'
        document.getElementById('nav2wrapper').style.transform = 'translate3d(0px, 0px, 0px)'
      }, 50)
    },
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (this.nav2Position === 0) this.nav2Position = document.querySelector('#nav2').offsetTop
      if (scrollTop >= this.nav2Position) {
        this.searchBarFixed = true
      } else {
        this.searchBarFixed = false
      }
    },
    scrollto (periodId) {
      this.period = periodId
    },
    wheretoGo (classId, jumpType, signUp) {
      jumpUrl(classId, jumpType, signUp)
    }
  },
  mounted () {
    this.getPeriods()
    this.getCourse1()
    this.getFreeListen()
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="stylus">
  #jsbs
    >>> #tophead
      padding: 0 .2rem
    .nav1
      height: .98rem
      line-height: .98rem
      border-bottom: .02rem solid #E5E5E5
      background-color: #fff
      a
        position: relative
        display: inline-block
        margin-left: .64rem
        font-size: .36rem
        color: #3D3C45
        font-weight: bold
        text-align: center
        &.active
          color: #FF7052
          &::after
            content: ""
            position: absolute
            left: 50%
            bottom: -.02rem
            display: block
            width: .48rem
            height: .08rem
            background-color: #FF7052
            margin-left: -.24rem
    .nav2
      position: static
      height: 1.18rem
      line-height: 1.18rem
      .swiper-slide
        width: auto!important
      a
        display: inline-block
        margin-left: .6rem
        font-size: .32rem
        color: #5E5E5E
        text-align: center;
        &:first-child
          margin-left: .2rem
          width: 1.5rem;
        &.active
          color: #FF7052
      &.fixed
        position: fixed
        top: 0
        left: 0
        z-index: 999
        width: 100%
        background-color: #fff
    #navout
      height: 1.18rem
    .degree
      position: relative
      padding: 0 .2rem .1rem
      border-bottom: .02rem solid #E5E5E5
      background-color: #F9F9F9
      .lightening
        position: absolute
        top: -1.18rem
        height: 1.18rem
      h2
        vertical-align: center
        line-height: 1.2rem
        font-size: .4rem
        color: #0C0C0C
        text-align: left
        &::before
          content: ""
          position: relative
          top: .04rem
          display: inline-block
          width: .08rem
          height: .4rem
          background-color: #FF7052
          margin-right: .12rem
        span.sub
          position: relative
          top: -.05rem
          display: inline-block
          width: 1.82rem
          height: .5rem
          line-height: .5rem
          background-color: #F3F3F3
          margin: 0 0 0 .2rem
          font-size: .24rem
          color: #9B9B9B
          text-align: center
          -webkit-border-radius: .25rem
          -moz-border-radius: .25rem
          border-radius: .25rem
      .course1
        display: flex
        justify-content: space-between
        margin-bottom: .4rem
        .left
          overflow: hidden
          width: 3.2rem
          height: 3.2rem
          img
            width: 100%
        .right
          position: relative
          width: 3.7rem
          height: 3.2rem
          h4
            overflow: hidden
            /*white-space: nowrap*/
            text-overflow: ellipsis
            font-size: .32rem
            color: #0C0C0C
            font-weight: bold
            text-align: left
          p
            overflow: hidden
            margin: .04rem 0
            /*white-space: nowrap*/
            text-overflow: ellipsis
            color: #9DA4B3
            &.detail
              font-size: .24rem
            &.people
              display: none
              font-size: .22rem
          & > div
            margin: .14rem 0
            span
              display: inline-block
              padding: .02rem .04rem
              border: .01rem solid #FF7052
              margin: 0 .05rem .05rem 0
              font-size: .22rem
              color: #FF7052
              -webkit-border-radius: .04rem
              -moz-border-radius: .04rem
              border-radius: .04rem
          b.price
            position: absolute
            bottom: 0
            left: 0
            display: block
            margin-top: .14rem
            font-size: .3rem
            color: #FF7052
            font-weight: 500
            span
              font-size: .4rem
              font-weight: 600
          a.bmst
            position: absolute
            bottom: 0
            right: 0
            display: block
            width: 1.52rem
            height: .56rem
            line-height: .56rem
            background-color: #FF7052
            font-size: .24rem
            color: #fff
            text-align: center
            -webkit-border-radius: .34rem
            -moz-border-radius: .34rem
            border-radius: .34rem
      .ad
        width: 7.1rem
        height: 1.44rem
        margin: .4rem auto 0
        img
          width: 100%
    .jszg2-banner
      img
        width: 7.5rem
        height: 3.6rem
    #free-listen
      padding: 0 .2rem
      h2
        vertical-align: center
        line-height: 1.2rem
        font-size: .4rem
        color: #0C0C0C
        text-align: left
        &::before
          content: ""
          position: relative
          top: .04rem
          display: inline-block
          width: .08rem
          height: .4rem
          background-color: #FF7052
          margin-right: .12rem
        span.subtitle
          position: relative
          top: -.05rem
          display: inline-block
          height: .5rem
          line-height: .5rem
          padding: 0 .2rem
          background-color: #F3F3F3
          margin: 0 0 0 .2rem
          font-size: .24rem
          color: #9B9B9B
          text-align: center
          -webkit-border-radius: .25rem
          -moz-border-radius: .25rem
          border-radius: .25rem
      .top
        overflow: hidden
        width: 7.1rem
        height: 4.38rem
        margin: 0 auto
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        -webkit-border-top-left-radius: .16rem
        -moz-border-top-left-radius: .16rem
        border-top-left-radius: .16rem
        -webkit-border-top-right-radius: .16rem
        -moz-border-top-right-radius: .16rem
        border-top-right-radius: .16rem
        img
          width: 100%
          height: 100%
      .bottom
        display: flex
        overflow: hidden
        width: 7.1rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        -webkit-border-bottom-left-radius: .16rem
        -moz-border-bottom-left-radius: .16rem
        border-bottom-left-radius: .16rem
        -webkit-border-bottom-right-radius: .16rem
        -moz-border-bottom-right-radius: .16rem
        border-bottom-right-radius: .16rem
        span
          width: 25%
          height: 1.2rem
          line-height: .4rem
          padding: .2rem 0
          background-color: #262D47
          font-size: .28rem
          color: #fff
          text-align: center
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          &.active
            background-color: #FF7052
    .reachbottom
      line-height: 1.5rem
      background-color: #f9f9f9
      font-size: .25rem
      color: #ccc
      letter-spacing: .05rem
      text-align: center
    #fix-bottom-void
      height: 1rem
      background-color: #f9f9f9
      clear: both
</style>



// WEBPACK FOOTER //
// src/components/webs/Jsms.vue